import { Box, Button, Checkbox, Tooltip, Typography, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import { UserContext } from '../context/UserContext';
import { tokens } from '../theme';
import axios from 'axios';
import { useNavigate } from 'react-router';

function IndependentCouponBox({ independentCoupon, onEditClick, onDeleteClick }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isFeatured, setIsFeatured] = useState(independentCoupon.is_featured === 1);
    const { token } = useContext(UserContext);
    const navigate = useNavigate();

    const updateFeatured = (featured) => {
        axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brand/updateIndependentCoupon?token=${token}&independentCouponId=${independentCoupon.id}`, {
            independentCoupon: {
                is_featured: featured ? 1 : 0
            }
        })
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    setIsFeatured(featured);
                }
            });
    }

    return (
        <Box m="10px" mb="20px" p="20px"
            width={"30%"}
            display="inline-block"
            sx={{
                background: (theme.palette.mode === "dark" ? colors.primary[500] : "white"), border: "1px solid " + colors.grey[500],
                borderRadius: "20px"
            }}
        >
            <Box display="flex" justifyContent="space-between">
                <Box display="flex" alignItems="center" >
                    <Box>
                        <img
                            alt="brand-logo"
                            src={independentCoupon.thumbnail_image_link}
                            width="40px"
                            height="40px"
                            style={{ cursor: "pointer", borderRadius: "20%" }} />
                    </Box>
                    <Box ml="10px">
                        <Box display="flex" gap="5px">
                            <Typography variant='h4'>{independentCoupon.brand_name}</Typography>
                            <Box padding="1px 10px" sx={{ background: independentCoupon.last_usage_date === null || new Date(independentCoupon.last_usage_date) >= new Date() ? colors.greenAccent[600] : colors.redAccent[600], borderRadius: "10px" }}>
                                <Typography variant='h6'>{independentCoupon.last_usage_date === null ? "Süresiz" : new Date(independentCoupon.last_usage_date) < new Date() ? "Geçmiş" : "Aktif"}</Typography>
                            </Box>
                        </Box>

                        {independentCoupon.coupon_title.length >= 70 ?
                            <Tooltip title={independentCoupon.coupon_title}>
                                <Typography variant='h6' color={colors.grey[100]}>{independentCoupon.coupon_title.slice(0, 70) + "..."}</Typography>
                            </Tooltip>
                            :
                            <Typography variant='h6' color={colors.grey[100]}>{independentCoupon.coupon_title}</Typography>
                        }
                    </Box>
                </Box>
                <Box display="flex">

                </Box>
            </Box>

            <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black") }} />
            <Box>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Kod:</b> <br />{independentCoupon.coupon_code || "-"}</Typography>

                {independentCoupon.brand_website.length >= 30 &&
                    <Tooltip title={independentCoupon.brand_website}>
                        <Typography variant='h6' mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={independentCoupon.brand_website} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{independentCoupon.brand_website.slice(0, 30) + "..."}</a></Typography>
                    </Tooltip>
                }
                {independentCoupon.brand_website.length < 30 &&
                    <Typography variant='h6' mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={independentCoupon.brand_website} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{independentCoupon.brand_website}</a></Typography>
                }

                {independentCoupon.coupon_description.length >= 80 &&
                    <Tooltip title={independentCoupon.coupon_description}>
                        <Typography variant='h6' mt="10px" ml="20px"><b>Kupon Açıklaması:</b> <br />{independentCoupon.coupon_description.slice(0, 70) + "..."}</Typography>
                    </Tooltip>
                }
                {independentCoupon.coupon_description.length < 80 &&
                    <Typography variant='h6' mt="10px" ml="20px"><b>Kupon Açıklaması:</b> <br />{independentCoupon.coupon_description}</Typography>
                }
                <Typography variant='h6' mt="10px" ml="20px"><b>Son Kullanma Tarihi:</b> <br />{independentCoupon.last_usage_date !== null ? new Date(independentCoupon.last_usage_date).toLocaleDateString() : "Süresiz"}</Typography>

                <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black"), marginTop: "20px" }} />

                <Typography variant='h6' mt="10px" ml="20px"><b>Kod Görüntülenme Sayısı:</b> <span style={{ marginLeft: "10px" }}>{independentCoupon.code_view_count}</span></Typography>
                <Typography variant='h6' mt="10px" ml="20px"><b>Websitesi Butonu Tıklama Sayısı:</b> <span style={{ marginLeft: "10px" }}>{independentCoupon.website_open_count}</span></Typography>
            </Box>

            <Box display="flex" alignItems="center" mt="10px" ml="10px">
                <Checkbox
                    checked={isFeatured}
                    onChange={(e) => {
                        updateFeatured(e.target.checked);
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    style={{ color: colors.blueAccent[500] }}
                />
                <Typography variant='h6' style={{ display: "inline-block" }}>Öne Çıkarılsın mı?</Typography>
            </Box>

            <Box display={"flex"} justifyContent={"space-evenly"} mt="10px">
                <Button variant='contained' sx={{ background: colors.blueAccent[500] }} onClick={() => onEditClick(independentCoupon)}>Düzenle</Button>
                <Button variant='contained' color='success' onClick={() => navigate(`/admin-panel/independent-coupon/${independentCoupon.id}`)}>Detay</Button>
                <Button variant='contained' color="error" onClick={() => onDeleteClick(independentCoupon)}>Sil</Button>
            </Box>
        </Box >
    )
}

export default IndependentCouponBox